import type { BgColors } from '@carboncopyco/ui';
import classNames from 'classnames';

export type BadgeSize = 'large' | 'medium' | 'small';

type HorizontalOrigin = 'left' | 'right';

type VerticalOrigin = 'top' | 'bottom';

interface Origin {
  horizontal: HorizontalOrigin;
  vertical: VerticalOrigin;
}

export interface BadgeProps {
  size?: BadgeSize;
  origin?: Origin;
  backgroundColor?: BgColors;
  show?: boolean;
  content?: React.ReactNode;
  children?: React.ReactNode;
}

const badgeSizes: Record<BadgeSize, string> = {
  large: 'w-4 h-4',
  medium: 'w-3 h-3',
  small: 'w-2.5 h-2.5',
};

const badgeHorizontalOrigins: Record<HorizontalOrigin, string> = {
  left: '-left-0.5',
  right: '-right-0.5',
};

const badgeVerticalOrigins: Record<VerticalOrigin, string> = {
  top: '-top-0.5',
  bottom: '-bottom-0.5',
};

export const Badge = ({
  size = 'medium',
  origin = { horizontal: 'right', vertical: 'bottom' },
  backgroundColor = 'bg-ds-accent3-100',
  show,
  content,
  children,
}: BadgeProps) => {
  return (
    <div className="relative">
      {children}
      <div
        className={classNames(
          'absolute rounded-full p-ds-0.25',
          badgeSizes[size],
          { hidden: !show },
          backgroundColor,
          badgeHorizontalOrigins[origin.horizontal],
          badgeVerticalOrigins[origin.vertical]
        )}
      >
        {content}
      </div>
    </div>
  );
};
